<template>
  <div class="main">
    <report-top></report-top>
    <div id="formTable">
      <div id="text">班次列表</div>
      <div id="ddas">
        <!-- <Button @click="reOpenWin" type="primary" size="small" icon="md-cloud-download">导出</Button>-->
        <Button @click="openAdd" type="primary" size="small">新增班次</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="classes">
        <ul>
          <li v-for="(x, index) in row.classesTimeList" :key="index">
            {{ x.name }}[{{ x.type }}]
            <span
              style="margin-left: 6px"
              v-for="(y, index) in x.timeList"
              :key="index"
            >
              {{ y.startTime }}-{{ y.endTime }}
            </span>
            <span>（{{ x.manNum }}人）</span>
          </li>
        </ul>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增班次' : '编辑班次'"
      footer-hide
      width="900"
      height="400"
      @on-cancel="cliclCancelBtn"
    >
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="8">
            <FormItem label="名称" prop="name">
              <Input v-model="item.name" placeholder="请输入"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="项目名称" prop="groupId">
              <selectItems
                :name="item.groupName"
                @update:name="item.groupName = $event"
                :id="item.groupId"
                @update:id="item.groupId = $event"
              ></selectItems>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="业务类型" prop="businessType">
              <Select v-model="item.businessType">
                <Option
                  v-for="(x, index) in $t('businessType')"
                  :value="x"
                  :key="index"
                  >{{ x }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="类型" prop="type">
              <Select v-model="item.type">
                <Option
                  v-for="(x, index) in $t('banciType')"
                  :value="x"
                  :key="index"
                  >{{ x }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="所属部门" prop="deptName">
              <selectGroup
                :name="item.deptName"
                @update:name="item.deptName = $event"
                :id="item.deptId"
                @update:id="item.deptId = $event"
              >
              </selectGroup>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="月休天数" prop="vacationDay">
              <InputNumber v-model="item.vacationDay"></InputNumber>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="负责人" prop="manager">
              <Input v-model="item.manager" placeholder="请输入"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="负责人电话" prop="tel">
              <Input
                v-model="item.tel"
                maxlength="11"
                show-word-limit
                type="number"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="备注" prop="remark">
              <Input v-model="item.remark" placeholder="请输入" />
            </FormItem>
          </Col>
          <Col span="24">
            <table id="personClass">
              <thead>
                <tr>
                  <td style="width: 100px">名称</td>
                  <td>时间设定</td>
                  <td>人数</td>
                  <td style="width: 100px">性质</td>
                  <td>备注</td>
                  <td>操作</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(x, index) in item.classesTimeList" :key="index">
                  <td><Input v-model="x.name"></Input></td>
                  <td>
                    <ul id="wewewe">
                      <li v-for="(y, key) in x.timeList" :key="key">
                        <Select v-model="y.startTime">
                          <Option
                            v-for="(x, index) in $t('times')"
                            :value="x"
                            :key="index"
                            >{{ x }}</Option
                          >
                        </Select>
                        <span>-</span>
                        <Select v-model="y.endTime">
                          <Option
                            v-for="(x, index) in $t('times')"
                            :value="x"
                            :key="index"
                            >{{ x }}</Option
                          >
                        </Select>
                        <Button
                          @click="delClass(index, key)"
                          :type="key == 0 ? 'success' : 'error'"
                          ghost
                          :icon="key == 0 ? 'md-add' : 'md-close'"
                        ></Button>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <InputNumber v-model="x.manNum"></InputNumber>
                  </td>
                  <td>
                    <Select v-model="x.type">
                      <Option
                        v-for="(x, index) in $t('personbanci')"
                        :value="x"
                        :key="index"
                        >{{ x }}</Option
                      >
                    </Select>
                  </td>
                  <td>
                    <Input v-model="x.remark"></Input>
                  </td>
                  <td>
                    <a @click="delCarClass(index)">{{
                      index == 0 ? "添加" : "删除"
                    }}</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="resetForm">重置表单</Button>
              <Button type="primary" @click="addUpdate('item')"
                >提交表单</Button
              >
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "名称",
          key: "name",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "业务类型",
          key: "businessType",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "类型",
          key: "type",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "项目名称",
          key: "groupName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "所属部门",
          key: "deptName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "班次设定",
          slot: "classes",
          minWidth: 260,
          maxWidth: 300,
        },
        {
          title: "月休天数",
          key: "vacationDay",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "负责人",
          key: "manager",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "负责人电话",
          key: "tel",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "备注信息",
          key: "remark",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建者账号",
          key: "createAccount",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        groupId: "1559850332318965761",
        groupName: "测试组",
        deptId: 1559850332318965761,
        deptName: "测试组",
        name: "test",
        vacationDay: 2,
        businessType: "清扫保洁",
        type: "大扫",
        classesTimeList: [
          {
            classesId: 11,
            name: "A班",
            type: "轮班",
            timeList: [
              {
                startTime: "06:00",
                endTime: "10:30",
              },
              {
                startTime: "14:00",
                endTime: "18:00",
              },
            ],
            manNum: 0,
            //sort: 0,
            //deleted: 0,
            remark: null,
          },
        ],
        remark: "",
        manager: "",
        tel: "",
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        groupId: { required: true, message: "必填" },
        businessType: { required: true, message: "必填" },
        deptName: { required: true, message: "必填" },
        type: { required: true, message: "必填" },
        startTime: { required: true, message: "必填" },
        endTime: { required: true, message: "必填" },
      },

      pageNumber: 1,
      pageSize: 50,
      total: 0,
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.swm + "/classes/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
        console.log(data);
      });
    },
    addUpdate(name) {
      console.log(this.item);
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.swm + "/classes/add",
              data: this.item,
            }).then((res) => {
              console.log(res);
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          } else {
            axios({
              method: "post",
              url: axios.swm + "/classes/update",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          }
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.swm + "/classes/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      console.log(row);
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.getList();
    },
    delCarClass(index) {
      console.log(index);
      if (index == 0) {
        this.addCarClass();
      } else {
        this.item.classesTimeList.splice(index, 1);
      }
    },
    delClass(index, key) {
      if (key == 0) {
        this.addClass(index);
      } else {
        this.item.classesTimeList[index].timeList.splice(key, 1);
      }
    },
    addClass(index) {
      var obj = { startTime: "06:00", endTime: "10:00" };

      this.item.classesTimeList[index].timeList.push(obj);
    },
    addCarClass() {
      var m = this.item.classesTimeList[0];
      this.item.classesTimeList.push(JSON.parse(JSON.stringify(m)));
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style>
#personClass {
  width: 100%;
  padding: 10px;
}
#personClass thead tr {
  background: #f1f1f1;
  height: 36px;
}
#personClass tbody tr {
  padding-bottom: 20px;
}
#personClass ul#wewewe {
  margin: 10px;
  position: relative;
}

#personClass ul#wewewe li {
  display: flex;
}
#personClass ul#wewewe li i {
  font-size: 18px;
  margin-left: 4px;
  margin-right: 4px;
}
#personClass ul#wewewe li span {
  line-height: 30px;
  margin: auto 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/person/bcsd.vue